import { memo, useEffect, useState } from 'react'
import { Template } from './Template'
import type { KcProps } from 'keycloakify'
import type { KcContext } from '../kcContext'
import { useKcMessage } from 'keycloakify/lib/i18n/useKcMessage'
import { useCssAndCx } from 'tss-react'
import { Button, Input, Form } from '@xanadu_ai/xanadu-component-library'

type KcContext_LoginUpdatePassword = Extract<
  KcContext,
  { pageId: 'login-update-password.ftl' }
>

export const LoginUpdatePassword = memo(
  ({
    kcContext,
    ...props
  }: { kcContext: KcContext_LoginUpdatePassword } & KcProps) => {
    const { cx } = useCssAndCx()

    const { msg, msgStr } = useKcMessage()

    const { url, messagesPerField, isAppInitiatedAction, username } = kcContext

    const [newPassword, updateNewPassword] = useState<string>('')
    const [confirmPassword, updateConfirmPassword] = useState<string>('')
    const [disableSubmit, toggleDisableSubmit] = useState<boolean>(true)

    useEffect(() => {
      toggleDisableSubmit(
        (!newPassword && !confirmPassword) || newPassword !== confirmPassword
      )
    }, [newPassword, confirmPassword])

    return (
      <Template
        {...{ kcContext, ...props }}
        doFetchDefaultThemeResources={false}
        headerNode={msg('updatePasswordTitle')}
        headerDescription="Join a community of learners, researchers, and developers to build the next generation of quantum technology."
        formNode={
          <Form
            formName="kc-passwd-update-form"
            action={url.loginAction}
            method="post"
            onSubmit={(_e: React.SyntheticEvent) => {}}
          >
            <>
              <Input
                fieldName="username"
                formName="kc-passwd-update-form"
                testId="username"
                type="text"
                value={username}
                className="hidden"
                onChange={(_value: string) => {}}
                fieldLabel="Username"
              />
              <Input
                type="password"
                fieldLabel="Password"
                formName="kc-passwd-update-form"
                fieldName="password"
                testId="password"
                className="hidden"
                onChange={(_value: string) => {}}
              />

              <div
                className={cx(
                  props.kcFormGroupClass,
                  messagesPerField.printIfExists(
                    'password',
                    props.kcFormGroupErrorClass
                  )
                )}
              >
                <div className={cx(props.kcInputWrapperClass)}>
                  <Input
                    formName="kc-passwd-update-form"
                    fieldName="password-new"
                    fieldLabel="New password"
                    testId="password-new"
                    className={cx(props.kcInputClass)}
                    type="password"
                    value={newPassword}
                    onChange={(value: string) => updateNewPassword(value)}
                  />
                </div>
              </div>

              <div
                className={cx(
                  props.kcFormGroupClass,
                  messagesPerField.printIfExists(
                    'password-confirm',
                    props.kcFormGroupErrorClass
                  )
                )}
              >
                <div className={cx(props.kcInputWrapperClass)}>
                  <Input
                    formName="kc-passwd-update-form"
                    fieldName="password-confirm"
                    fieldLabel="Confirm password"
                    testId="password-confirm"
                    className={cx(props.kcInputClass)}
                    type="password"
                    value={confirmPassword}
                    onChange={(value: string) => updateConfirmPassword(value)}
                  />
                </div>
              </div>

              <div className={cx(props.kcFormGroupClass)}>
                <div
                  id="kc-form-options"
                  className={cx(props.kcFormOptionsClass)}
                >
                  <div className={cx(props.kcFormOptionsWrapperClass)}>
                    {isAppInitiatedAction && (
                      <div className="checkbox">
                        <label>
                          <input
                            type="checkbox"
                            id="logout-sessions"
                            name="logout-sessions"
                            value="on"
                            checked
                          />
                          {msgStr('logoutOtherSessions')}
                        </label>
                      </div>
                    )}
                  </div>
                </div>

                <div
                  id="kc-form-buttons"
                  className={cx(props.kcFormButtonsClass)}
                >
                  {isAppInitiatedAction ? (
                    <>
                      <Button
                        testId="submit-button"
                        className="justify-center mb-4"
                        buttonType="submit"
                        label="Submit"
                        disabled={disableSubmit}
                      />
                      <Button
                        testId="cancel-button"
                        type="secondary"
                        className="justify-center"
                        buttonType="submit"
                        label="Cancel"
                      />
                    </>
                  ) : (
                    <Button
                      testId="submit-button"
                      className="justify-center"
                      buttonType="submit"
                      label="Submit"
                      disabled={disableSubmit}
                    />
                  )}
                </div>
              </div>
            </>
          </Form>
        }
      />
    )
  }
)
